var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 19",
    style: {
      enableBackground: "new 0 0 18 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,8.8h4.5c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5s-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2H8.2 C8,7.3,7.9,7.3,7.7,7.5C7.6,7.6,7.5,7.8,7.5,8s0.1,0.4,0.2,0.5C7.9,8.7,8,8.8,8.2,8.8z M8.2,11h1.5c0.2,0,0.4-0.1,0.5-0.2 c0.1-0.1,0.2-0.3,0.2-0.5s-0.1-0.4-0.2-0.5C10.1,9.6,10,9.5,9.7,9.5H8.2C8,9.5,7.9,9.6,7.7,9.7C7.6,9.9,7.5,10,7.5,10.2 s0.1,0.4,0.2,0.5C7.9,10.9,8,11,8.2,11z M8.2,6.5h4.5c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5s-0.1-0.4-0.2-0.5 C13.1,5.1,13,5,12.7,5H8.2C8,5,7.9,5.1,7.7,5.2C7.6,5.4,7.5,5.5,7.5,5.8s0.1,0.4,0.2,0.5C7.9,6.4,8,6.5,8.2,6.5z M6,14 c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.4-0.6-0.4-1.1v-9c0-0.4,0.1-0.8,0.4-1.1C5.2,2.1,5.6,2,6,2h9c0.4,0,0.8,0.1,1.1,0.4 c0.3,0.3,0.4,0.6,0.4,1.1v9c0,0.4-0.1,0.8-0.4,1.1C15.8,13.9,15.4,14,15,14H6z M6,12.5h9v-9H6V12.5z M3,17c-0.4,0-0.8-0.1-1.1-0.4 c-0.3-0.3-0.4-0.6-0.4-1.1V5.8c0-0.2,0.1-0.4,0.2-0.5C1.9,5.1,2,5,2.2,5c0.2,0,0.4,0.1,0.5,0.2C2.9,5.4,3,5.5,3,5.8v9.8h9.8 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5C13.1,16.9,13,17,12.7,17H3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineLearning);
export default __webpack_public_path__ + "static/media/OnlineLearning.7ec5c63d7bbdb7a7f5e4aab45e70239d.svg";
export { ForwardRef as ReactComponent };